module.exports = __webpack_public_path__ + "img/cover11.e8df4741.jpg";